import React from 'react';

const NotFound = () => {
    return (
        <div>
            <img style={{ maxWidth: "100%" }} src="https://i.ibb.co/p31VgqC/404-1.jpg" alt="404image" />
        </div>
    );
};

export default NotFound;